import React from 'react';
import { Link } from 'react-router-dom';

import './Logo.scss';

type LogoComponentProps = {
  showText?: boolean;
  size?: 'small' | 'medium' | 'header';
};

function Logo({ showText, size = 'header' }: LogoComponentProps) {
  return (
    <div className={`logo logo--${size}`}>
      {size !== 'small' ? (
        <Link to={'/home'}>
          parlaypicker.<span className="logo--active">us</span>
        </Link>
      ) : size === 'small' ? (
        <a href="javascript:void(0)" className={'logo--small'}>
          parlaypicker.<span className="logo--active">us</span>
        </a>
      ) : null}
      {showText && (
        <div className={'logo--text'}>
          making <span>you</span> the house advantage
        </div>
      )}
    </div>
  );
}

export default Logo;
